<template>
  <div class="c-vod-distribute">
    <plv-dialog
      width="400px"
      show-footer-btn
      :visible="visible"
      :title="type === 'add' ? '添加用量' : '回收用量'"
      :close-on-click-mask="false"
      :closable="false"
      @confirm="handleSubmit"
      @cancel="handleDialogClose"
      @close="handleDialogClose"
    >
      <plv-form
        ref="form"
        :form="form"
        label-width="50px"
      >
        <plv-form-item label="空间">
          <template v-if="isResourceLimit && type === 'add' " slot="tips">
            <span>{{ $_getSpaceTip(form.space) }}</span>
          </template>
          <template v-else-if="type === 'recycle'" slot="tips">
            <span>{{ $_getResourceRecycleTip(assignedForm.space, 'G') }}</span>
          </template>
          <plv-input-number
            v-model="form.space"
            placeholder="请输入空间容量"
            :en-length="1"
            :max="type === 'recycle' ? assignedForm.space : 100000000"
          >
            <template slot="suffix">
              <span class="p-vod-setting-form-item__unit">GB</span>
            </template>
          </plv-input-number>
        </plv-form-item>

        <plv-form-item label="流量">
          <template v-if="isResourceLimit && type === 'add' " slot="tips">
            <span>{{ $_getFlowTip(form.flow) }}</span>
          </template>
          <template v-else-if="type === 'recycle'" slot="tips">
            <span>{{ $_getResourceRecycleTip(assignedForm.flow, 'G') }}</span>
          </template>
          <plv-input-number
            v-model="form.flow"
            placeholder="请输入流量容量"
            :en-length="1"
            :max="type === 'recycle' ? assignedForm.flow : 100000000"
          >
            <template slot="suffix">
              <span class="p-vod-setting-form-item__unit">GB</span>
            </template>
          </plv-input-number>
        </plv-form-item>
      </plv-form>
      <div v-if="!isResourceLimit && type === 'add'" class="c-vod-distribute__tip">
        <plv-tips>当前主账号不限制分配资源量，分账号的消耗仍会汇总到主账号结算</plv-tips>
      </div>
    </plv-dialog>
  </div>
</template>

<script>
import dialogMixin from '@/mixins/dialog';
import accountInfoMixin from '@/mixins/accountInfo';
const defaultForm = {
  flow: 0,
  space: 0,
  unionId: ''
};
export default {
  mixins: [dialogMixin, accountInfoMixin],
  data() {
    return {
      type: 'add',
      form: { ...defaultForm },
      loading: false,
      assignedForm: {}
    };
  },
  methods: {
    open(type, data) {
      this.type = type;
      this.form.unionId = data.unionId;
      if (type === 'recycle') {
        this.assignedForm = { ...data };
      }
      this.$emit('update:visible', true);
    },
    async handleSubmit() {
      if (this.loading) return;
      const isAdd = this.type === 'add';
      const form = {
        flow: isAdd ? this.form.flow : -this.form.flow,
        space: isAdd ? this.form.space : -this.form.space,
        unionId: this.form.unionId
      };
      this.loading = true;
      try {
        await this.$store.dispatch('account/allocateVodResource', form);
        // 后端重新设置有延迟
        setTimeout(async () => await this.$store.dispatch('account/getOverViewInfo'), 1000);
      } finally {
        this.loading = false;
      }
      this.$emit('updateSuccess', form);
    },
    handleDialogClose() {
      this.handleClose();
      this.form = { ...defaultForm };
    }
  }
};
</script>

<style>
.c-vod-distribute__tip {
  margin-top: 14px;
}
</style>
